import './JiraCredentialsForm.scss';
import { integrationsActions } from '@sonar-software/sonar-integrations';
import Link from 'antd/es/typography/Link';
import { Button, Form, Input } from 'antd';
import { COPY_SPECIFIC, INTEGRATIONS_COPY, PLACEHOLDERS_COPY } from '@sonar-software/sonar-ts-constants';
import { jiraIntegrationSelectors, jiraSummarySelectors } from './@arch/selectors';
import React, { useCallback } from 'react';
import { useAction, useCurrentUser, useOnMount, useSonarSelector } from '@hooks';
const getRequiredMessage = (label) => COPY_SPECIFIC.FIELD_REQUIRED(label);
const ApiKeyTooltip = () => React.createElement("div", { className: 'jira-help-url' },
    COPY_SPECIFIC.NEED_HELP_CREATING_API_TOKEN,
    React.createElement(Link, { href: INTEGRATIONS_COPY.JIRA_HELP_URL, target: 'blank' }, COPY_SPECIFIC.VISIT_ATLASSIAN_HELP_PAGE));
export const JiraCredentialsForm = ({ form, onUpdate }) => {
    const { customerId, isReadOnly } = useCurrentUser();
    const jiraSummary = useSonarSelector(jiraSummarySelectors.data);
    const isIntegrationRequested = useSonarSelector(jiraIntegrationSelectors.isRequested);
    const putJiraCredentials = useAction(integrationsActions.requestPutJiraCredentials);
    const postJiraCredentials = useAction(integrationsActions.requestPostJiraCredentials);
    const submitButtonText = isIntegrationRequested ? COPY_SPECIFIC.SUBMITTING : COPY_SPECIFIC.CONNECT_YOUR_INSTANCE;
    useOnMount(() => {
        form.resetFields();
    });
    const handleConnect = useCallback((values) => {
        const apiService = (jiraSummary === null || jiraSummary === void 0 ? void 0 : jiraSummary.connected) ? putJiraCredentials : postJiraCredentials;
        apiService({
            apiToken: values.token,
            customerId,
            url: values.url,
            username: values.username
        });
    }, [customerId, jiraSummary, postJiraCredentials, putJiraCredentials]);
    return (React.createElement(Form, { className: 'jira-credentials-form', disabled: isReadOnly, form: form, layout: 'vertical', name: 'jira-integration', onFinish: handleConnect },
        React.createElement(Form.Item, { initialValue: jiraSummary === null || jiraSummary === void 0 ? void 0 : jiraSummary.url, label: INTEGRATIONS_COPY.JIRA_URL, name: 'url', rules: [{
                    message: getRequiredMessage(INTEGRATIONS_COPY.JIRA_URL),
                    required: true
                }], tooltip: INTEGRATIONS_COPY.URL_USING_FOR_JIRA },
            React.createElement(Input, { onChange: onUpdate, placeholder: INTEGRATIONS_COPY.JIRA_URL_PLACEHOLDER })),
        React.createElement(Form.Item, { initialValue: jiraSummary === null || jiraSummary === void 0 ? void 0 : jiraSummary.username, label: COPY_SPECIFIC.USERNAME, name: 'username', rules: [{
                    message: getRequiredMessage(COPY_SPECIFIC.USERNAME),
                    required: true
                }], tooltip: COPY_SPECIFIC.USERNAME_TO_AUTHENTICATE_WITH },
            React.createElement(Input, { onChange: onUpdate, placeholder: PLACEHOLDERS_COPY.ENTER_YOUR_USERNAME })),
        React.createElement(Form.Item, { initialValue: jiraSummary === null || jiraSummary === void 0 ? void 0 : jiraSummary.apiToken, label: COPY_SPECIFIC.API_KEY_TOKEN, name: 'token', rules: [{
                    message: getRequiredMessage(COPY_SPECIFIC.API_KEY_TOKEN),
                    required: true
                }], tooltip: React.createElement(ApiKeyTooltip, null) },
            React.createElement(Input.Password, { onChange: onUpdate, placeholder: PLACEHOLDERS_COPY.ENTER_YOUR_API_KEY })),
        !onUpdate &&
            React.createElement(Button, { htmlType: 'submit', id: 'generate-jira-integration-url', loading: isIntegrationRequested, type: 'primary' }, submitButtonText)));
};
